// [KAYIT-HATA] (Baris, 17 Eki 2026) Ortak form hata gosterimi — bir form istegi hata verdiginde kullanici HER ZAMAN gorunur bir
// mesaj gorur, girdigi bilgiler silinmez, dugme yeniden basilabilir.
//  - 422 (backend VAL_INVALID_INPUT, details.errors[].field = "body.<alan>"): mesaj ilgili alanin ALTINDA (formik setFieldError),
//    ilk hatali alana kaydirilir ve odaklanir; formda olmayan alan genel mesaja eklenir.
//  - 409 / 429 / ag hatasi / 5xx: sade genel mesaj (cagiran sayfa formun icinde, dugmenin yaninda gosterir) + bildirim (App.tsx kok kutusu).
// api.ts hatasi: buildApiError -> err.status, err.detail (= details), err.message.

import { toast } from "react-toastify";

export type HataTuru = "alan" | "cakisma" | "sinir" | "ag" | "sunucu" | "diger";

export interface FormHatasi {
  tur: HataTuru;
  genel: string;                       // formun icinde gosterilecek metin (bos olabilir: yalniz alan hatasi)
  alanlar: Record<string, string>;     // alan adi -> alanin altindaki metin
}

export interface FormHatasiSecenek {
  cakismaMesaji?: string;              // 409 icin sayfaya ozel metin (or. kayit: "e-posta kayitli")
  alanAdlari?: string[];               // formdaki alanlar (422 eslemesi icin); verilmezse formik.values anahtarlari
  bildirim?: boolean;                  // varsayilan true: genel mesaj ayrica toast.error
}

const ALAN_ETIKET: Record<string, string> = {
  first_name: "First name", last_name: "Last name", email: "Email", password: "Password", country: "Country",
};

function sadeMesaj(alan: string, m: string): string {
  const t = (m || "").replace(/^Value error,\s*/i, "").trim();
  if (/at least \d+ characters?/i.test(t) || /at most \d+ characters?/i.test(t) || /should have at/i.test(t)) {
    const etiket = ALAN_ETIKET[alan] || "This field";
    const sayi = t.match(/\d+/);
    if (/at least|should have at least/i.test(t) && sayi) return `${etiket} must be at least ${sayi[0]} characters`;
    if (sayi) return `${etiket} must be at most ${sayi[0]} characters`;
  }
  if (/valid email|email address/i.test(t)) return "Please enter a valid email address";
  if (/field required|missing/i.test(t)) return `${ALAN_ETIKET[alan] || "This field"} is required`;
  return t || "Please check this field";
}

/** Yakalanan hatayi turune gore cozer (sayfa/formik'e dokunmaz). */
export function formHatasiCoz(err: any, secenek: FormHatasiSecenek = {}): FormHatasi {
  const durum: number | undefined = err?.status ?? err?.apiError?.status;
  const ayrinti = err?.detail ?? err?.apiError?.details;
  if (durum === 422 && Array.isArray(ayrinti?.errors)) {
    const alanlar: Record<string, string> = {};
    const disarida: string[] = [];
    for (const e of ayrinti.errors) {
      const yol = String(e?.field || "").split(".");
      const alan = yol[yol.length - 1];
      const metin = sadeMesaj(alan, e?.message);
      if (!secenek.alanAdlari || secenek.alanAdlari.includes(alan)) {
        if (!alanlar[alan]) alanlar[alan] = metin;
      } else disarida.push(metin);
    }
    return { tur: "alan", genel: disarida.length ? disarida.join(" ") : "Please correct the highlighted fields.", alanlar };
  }
  if (durum === 409) return { tur: "cakisma", genel: secenek.cakismaMesaji || err?.message || "This item already exists.", alanlar: {} };
  if (durum === 429) return { tur: "sinir", genel: "Too many attempts. Please wait 1 minute and try again.", alanlar: {} };
  if (durum === undefined && (err instanceof TypeError || /failed to fetch|network/i.test(String(err?.message || "")))) {
    return { tur: "ag", genel: "We couldn't reach the server. Please check your connection and try again.", alanlar: {} };
  }
  if (durum !== undefined && durum >= 500) {
    return { tur: "sunucu", genel: "Something went wrong on our side. Please try again in a moment.", alanlar: {} };
  }
  return { tur: "diger", genel: err?.message || "Something went wrong. Please try again.", alanlar: {} };
}

/** Formik formuna uygular: alan hatalarini alanlarin altina yazar, ilk hatali alana kaydirip odaklar; genel mesaji bildirir. */
export function formHatasiUygula(err: any, formik: any, secenek: FormHatasiSecenek = {}): FormHatasi {
  const alanAdlari = secenek.alanAdlari || Object.keys(formik?.values || {});
  const h = formHatasiCoz(err, { ...secenek, alanAdlari });
  const adlar = Object.keys(h.alanlar);
  if (formik && adlar.length) {
    formik.setTouched({ ...(formik.touched || {}), ...Object.fromEntries(adlar.map((a) => [a, true])) }, false);
    formik.setErrors({ ...(formik.errors || {}), ...h.alanlar });
    const ilk = alanAdlari.find((a) => h.alanlar[a]);
    if (ilk && typeof document !== "undefined") {
      const el = document.querySelector(`[name="${ilk}"]`) as HTMLElement | null;
      if (el) {
        try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch { /* eski tarayici */ }
        el.focus({ preventScroll: true } as any);
      }
    }
  }
  if (secenek.bildirim !== false) toast.error(adlar.length ? "Please correct the highlighted fields." : h.genel);
  return h;
}
